import { createStore } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

export const transactionSummaryStore = createStore(

    (set, get) => ({
        loadingRejectCodes: false,
        setLoadingRejectCodes: (loadingRejectCodes: boolean) => set({ loadingRejectCodes }),
        setTableQueryAbortController: (tableQueryAbortController) => set({ tableQueryAbortController }),
        tableQueryAbortController: null,
        setLoadingSearchResults: (loadingSearchResults: boolean) => set({ loadingSearchResults }),
        loadingSearchResults: false
    })



)